import React, { useEffect, useState } from "react";
import { getAllServices } from "../../apis/services";
import MultiSelect from "../fromComponents/MultiSelect";

export interface Service {
  name: string;
  publicId: string;
}

interface SearchServiceMultiProps {
  className?: string;
  label: string;
  id: string;
  setValues: any;
  values: MultiSelectOptionType[];
}

const SearchServiceMultiSelect: React.FC<SearchServiceMultiProps> = ({
  className,
  label,
  id,
  setValues,
  values,
}) => {
  const [search, setSearch] = useState<MultiSelectOptionType[]>([]);

  const getServices = async () => {
    const [response, error] = await getAllServices();
    if (response) {
      const results = response.map((element: Service) => ({
        label: element.name,
        publicId: element.publicId,
      }));
      setSearch(results);
    } else {
      console.log(error);
    }
  };

  useEffect(() => {
    getServices();
  }, []);

  return (
    <MultiSelect
      className={className}
      label={label}
      options={search}
      value={values}
      setValue={setValues}
      name={""}
      id={""}
    />
  );
};

export default SearchServiceMultiSelect;
